<script setup>
import { computed, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import Loading from '@/components/Loading.vue';
import { useStore } from 'vuex';
import Modal from '@/components/Modal.vue';

defineOptions({
  name: 'App',
});

const router = useRouter();
const currentRoute = useRoute();

const therapistImage = computed(() => {
  return store.getters.therapistImage;
});
const backgroundClass = computed(() => {
  if (currentRoute.name === 'TherapyRoom') {
    return 'bgleft ' + therapistImage.value;
  }
  return 'bg ' + currentRoute.name;
});

const version = ref('');
const checkServerVersion = async () => {
  const response = await store.dispatch('get', {
    end_point: 'getVersion',
  });
  version.value = `(v${response.version})`;
};

const store = useStore();
onMounted(() => {
  checkServerVersion();
});

// "undefined" means the URL will be computed from the `window.location` object

const isLoggedIn = computed(() => store.getters.isLoggedIn);
const modalList = computed(() => store.getters['modal/getModalList']);
</script>
<template>
  <div class="app is-size-5-mobile is-size-4-tablet is-size-3-desktop">
    <div :class="backgroundClass"></div>
    <div v-for="(modal, index) in modalList" :key="index">
      <Modal :modal="modal" :index="index"></Modal>
    </div>
    <Loading></Loading>
    <nav v-if="isLoggedIn">
      <ul>
        <li v-for="(route, index) in router.options.routes" :key="index">
          <router-link
            v-if="route.meta && route.meta.inNav"
            class="button is-primary"
            :to="route.path"
          >
            {{ route.name }}
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="router-view">
      <router-view />
    </div>
  </div>
  <footer>
    <a
      class="is-size-6-mobile is-size-5-tablet"
      href="https://www.studiokromhout.nl"
      target="_blank"
      >Studio Kromhout 2024 {{ version }}
    </a>
  </footer>
</template>

<style lang="scss" scoped>
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  margin: $defaultSize;

  a {
    color: white;
    &:hover {
      color: $primary;
    }
  }
}
.full {
  width: 100%;
  padding: 3vw;
}
ul {
  list-style: none;
  display: flex;
}
li {
  margin: 0.1rem;
}
.router-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.app {
  padding: $margin $margin $defaultSize * 2 $margin;
}

.bg {
  background-size: cover; /* Cover the entire area without changing aspect ratio */
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  width: 100vw; /* Full viewport width */
  height: 100vh; /* Full viewport height */
  position: fixed; /* Fix the position relative to the viewport */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Center the background */
  z-index: -1; /* Ensure it is behind other content */
}

.bgleft {
  background-size: cover; /* Cover the entire area without changing aspect ratio */
  background-position: 30% center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  width: 100vw; /* Full viewport width */
  height: 100vh; /* Full viewport height */
  position: fixed; /* Fix the position relative to the viewport */
  top: 0;
  left: 0;
  transform: none;
  z-index: -1; /* Ensure it is behind other content */
}

.ImageAlpha,
.TherapyMenu,
.TherapyView,
.ChatView,
.ChatMenu,
.Login,
.Home {
  background-color: $primary;
}
.Home {
  background-image: url('/images/home.jpg');
}

.drkrenk {
  background-image: url('/images/drkrenk.jpg');
}
.drlangteen {
  background-image: url('/images/drlangteen.jpg');
}
.drwiekschot {
  background-image: url('/images/drwiekschot.jpg');
}

.WaitingRoom {
  background-image: url('/images/waitingroom.jpg');
}

.RecuperRoom {
  background-image: url('/images/recuperroom.jpg');
}
</style>
